/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_Stat_Not_PublishedInputs */

const en_seller_dashboard_stat_not_published = /** @type {(inputs: Seller_Dashboard_Stat_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not published`)
};

const es_seller_dashboard_stat_not_published = /** @type {(inputs: Seller_Dashboard_Stat_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no publicado`)
};

const fr_seller_dashboard_stat_not_published = /** @type {(inputs: Seller_Dashboard_Stat_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`non publié`)
};

const de_seller_dashboard_stat_not_published = /** @type {(inputs: Seller_Dashboard_Stat_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht veröffentlicht`)
};

const ja_seller_dashboard_stat_not_published = /** @type {(inputs: Seller_Dashboard_Stat_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未公開`)
};

const zh_seller_dashboard_stat_not_published = /** @type {(inputs: Seller_Dashboard_Stat_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未发布`)
};

const ar_seller_dashboard_stat_not_published = /** @type {(inputs: Seller_Dashboard_Stat_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير منشور`)
};

const id_seller_dashboard_stat_not_published = /** @type {(inputs: Seller_Dashboard_Stat_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`belum diterbitkan`)
};

const it_seller_dashboard_stat_not_published = /** @type {(inputs: Seller_Dashboard_Stat_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`non pubblicato`)
};

const ru_seller_dashboard_stat_not_published = /** @type {(inputs: Seller_Dashboard_Stat_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`не опубликовано`)
};

const pt_seller_dashboard_stat_not_published = /** @type {(inputs: Seller_Dashboard_Stat_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`não publicados`)
};

const ko_seller_dashboard_stat_not_published = /** @type {(inputs: Seller_Dashboard_Stat_Not_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미게시`)
};

/**
* | output |
* | --- |
* | "not published" |
*
* @param {Seller_Dashboard_Stat_Not_PublishedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_stat_not_published = /** @type {((inputs?: Seller_Dashboard_Stat_Not_PublishedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_Stat_Not_PublishedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_stat_not_published(inputs)
	if (locale === "es") return es_seller_dashboard_stat_not_published(inputs)
	if (locale === "fr") return fr_seller_dashboard_stat_not_published(inputs)
	if (locale === "de") return de_seller_dashboard_stat_not_published(inputs)
	if (locale === "ja") return ja_seller_dashboard_stat_not_published(inputs)
	if (locale === "zh") return zh_seller_dashboard_stat_not_published(inputs)
	if (locale === "ar") return ar_seller_dashboard_stat_not_published(inputs)
	if (locale === "id") return id_seller_dashboard_stat_not_published(inputs)
	if (locale === "it") return it_seller_dashboard_stat_not_published(inputs)
	if (locale === "ru") return ru_seller_dashboard_stat_not_published(inputs)
	if (locale === "pt") return pt_seller_dashboard_stat_not_published(inputs)
	return ko_seller_dashboard_stat_not_published(inputs)
});